/**
 * DepreciationMethodService
 * Service for DepreciationMethod lookup CRUD operations
 */
import { CrudService } from '../base/CrudService';
/** Service for DepreciationMethod CRUD operations */
export class DepreciationMethodService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? DepreciationMethodService.DEFAULT_SERVICE_PATH,
            basePath: DepreciationMethodService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
DepreciationMethodService.DEFAULT_SERVICE_PATH = 'assetmanagement';
DepreciationMethodService.BASE_PATH = 'api/asset-depreciation-methods';
//# sourceMappingURL=DepreciationMethodService.js.map